/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_card_enterprise_security_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Player Protection`)
};

const zh_hans1_card_enterprise_security_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`玩家及账户保护`)
};

const zh_hant1_card_enterprise_security_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`玩家與帳戶保護`)
};

const fr_card_enterprise_security_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protection des joueurs`)
};

const de_card_enterprise_security_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spielerschutz`)
};

const ja_card_enterprise_security_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレイヤー保護`)
};

const ko_card_enterprise_security_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`플레이어 보호`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const card_enterprise_security_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.card_enterprise_security_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("card_enterprise_security_title", locale)
	if (locale === "en") return en_card_enterprise_security_title(inputs)
	if (locale === "zh-Hans") return zh_hans1_card_enterprise_security_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_card_enterprise_security_title(inputs)
	if (locale === "fr") return fr_card_enterprise_security_title(inputs)
	if (locale === "de") return de_card_enterprise_security_title(inputs)
	if (locale === "ja") return ja_card_enterprise_security_title(inputs)
	return ko_card_enterprise_security_title(inputs)
};